import {Inject, Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import {PREFFERED_LANGUAGE} from '@core/constants/localstorage-keys';
import {LanguageService} from '@core/services/language.service';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {Store} from '@ngxs/store';
import {CurrentClientState} from '@store/current-client/current-client.state';
import {filter, map, Observable, of, switchMap} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguagePrefixGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const languageConfig$ = this.store.select(CurrentClientState.getData).pipe(
      map(data => data?.config?.language),
      filter(Boolean),
    );

    return languageConfig$.pipe(
      switchMap(languageConfig => {
        if (
          (languageConfig.available_languages as string[]).includes(route.url[0]?.path)
        ) {
          return of(true);
        }

        const newLanguage =
          route.queryParams.prefferedLanguage ||
          this.languageService.currentLanguage$.getValue() ||
          this.localStorage.getItem(PREFFERED_LANGUAGE) ||
          languageConfig.default;

        return this.languageService.setLanguage(newLanguage).pipe(
          map(() =>
            this.router.createUrlTree(
              ['/', newLanguage, ...route.url.map(url => url.path)],
              {
                queryParams: {
                  ...route.queryParams,
                  prefferedLanguage: undefined,
                  code: undefined,
                },
                queryParamsHandling: 'merge',
                preserveFragment: true,
              },
            ),
          ),
        );
      }),
    );
  }

  constructor(
    readonly router: Router,
    readonly languageService: LanguageService,
    readonly store: Store,
    @Inject(LOCAL_STORAGE) readonly localStorage: Storage,
  ) {}
}
